var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"min-height":"calc(100vh - 13.5rem)"},attrs:{"id":"app"}},[_c('MySidebar'),_c('router-view'),(_vm.isLoading)?_c('MyLoading'):_vm._e()],1),_c('MyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }